import React, { useEffect, useState } from "react";
import "./DepartmentTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Button } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

export default function DepartmentTable(props) {
  const [departmentData, setDepartmentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);

  const defaultColDef = {
    resizable: true,
    width: 590,
    filter: "agTextColumnFilter",
    // filter: true ,
  };

  const renderButton = (params) => {
    // // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => onDepartmentDelete(params.data.data["_id"])}
      />
    );
  };
  const renderEditButton = (params) => {
    // // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faEdit}
        onClick={() => props.onEditDepartment(params.data.data)}
      />
    );
  };

  const columnDefs = [
    {
      headerName: "Department",
      field: "DepartmentName",
      sortable: true,
      width: 150,
      // filter: true ,
    },
    {
      headerName: "Head of Department",
      field: "HeadOfDept",
      sortable: true,
      width: 150,
      // filter: true ,
    },
    {
      headerName: "Company",
      field: "CompanyName",
      sortable: true,
      width: 150,
      // filter: true ,
    },
    {
      headerName: "",
      field: "edit",
      filter: false,
      width: 30,
      cellRendererFramework: renderEditButton,
    },
    {
      headerName: "",
      field: "delete",
      filter: false,
      width: 30,
      cellRendererFramework: renderButton,
    },
  ];
  const getRowHeight = (params) => {
    return 35;
  };

  let departmentObj = [];
  let rowDataT = [];

  const loadDepartmentData = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/department", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        departmentObj = response.data;
        // console.log("response", response.data);
        setDepartmentData(response.data);
        setLoading(false);

        rowDataT = [];

        departmentData.forEach((data) => {
          rowDataT.push({
            data,
            CompanyName: data["company"][0]["CompanyName"],
            DepartmentName: data["DepartmentName"],
            HeadOfDept:
              data["hod"][0]["FirstName"] + " " + data["hod"][0]["LastName"],
          });
        });
        setRowData(rowDataT);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onDepartmentDelete = (e) => {
    console.log(e);
    if (window.confirm("Are you sure to delete this record ? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/department/" +
            e,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          props.setTable(false);
          props.setTable(true);
          loadDepartmentData();
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          if (err.response.status === 403) {
            window.alert(err.response.data);
          }
        });
    }
  };
  useEffect(() => {
    const loadDepartmentDataBegin = () => {
      axios
        .get("https://almawridems.javedahmadghamidi.com/api/ems/department", {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        })
        .then((response) => {
          // console.log("response", response.data);
          setDepartmentData(response.data);
          setLoading(false);

          let rowDataTT = [];

          response.data.forEach((data) => {
            rowDataTT.push({
              data,
              CompanyName: data["company"][0]["CompanyName"],
              DepartmentName: data["DepartmentName"],
              HeadOfDept:
                data["hod"][0]["FirstName"] + " " + data["hod"][0]["LastName"],
            });
          });
          setRowData(rowDataTT);
        })
        .catch((error) => {
          console.log(error);
        });
    };
    loadDepartmentDataBegin();
  }, []);

  return (
    <div id="table-outer-div-scroll">
      <h2 id="role-title">Department Details</h2>
      <Button variant="primary" id="add-button" onClick={props.onAddDepartment}>
        <FontAwesomeIcon icon={faPlus} id="plus-icon" />
        Add
      </Button>

      <div id="clear-both" />
      {!loading ? (
        <div
          id="table-div"
          className="ag-theme-balham"
          //   style={
          //     {
          //     height: "500px",
          //     width: "100%"
          //   }
          // }
        >
          <AgGridReact
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowData={rowData}
            pagination={true}
            paginationPageSize={10}
            getRowHeight={getRowHeight}
          />
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </div>
  );
}
